<template>
    <svg
        data-testid="closinglock-logo"
        :height
        viewBox="0 0 125 28"
        :width
        xmlns="http://www.w3.org/2000/svg"
    >
        <path
            id="path1"
            class="primary"
            d="M 18.097205,3.3787433 5.6145251,11.459026 v 8.657817 c 0,1.244977 1.0132767,2.258256 2.2582596,2.258256 H 17.877608 c 1.244976,0 2.258256,-1.013279 2.258256,-2.258256 V 11.459026 L 15.043538,8.1425312 18.066083,6.1903289 23.414322,9.6814678 V 21.548568 c 0,2.26345 -1.845006,4.103261 -4.108443,4.103261 H 6.4393257 c -2.2634465,0 -4.1032547,-1.839811 -4.1032547,-4.103261 V 9.6883843 L 15.069481,1.4040633 12.925339,0 0,8.4036317 V 21.78028 C 0.12449829,25.231644 2.9654789,28 6.4393257,28 H 19.302412 c 3.480758,0 6.314828,-2.766631 6.439331,-6.21972 V 8.4088187 Z M 17.785952,12.73167 v 7.293533 H 7.9575127 V 12.73167 L 12.88557,9.539678 Z"
            style="stroke-width: 0.172921"
        />
        <path
            id="path2"
            class="primary"
            d="m 37.105659,22.599891 c -1.910703,0 -3.53955,-0.648432 -4.710182,-1.877855 -1.122214,-1.177538 -1.739508,-2.844428 -1.739508,-4.694614 0,-3.869823 2.659422,-6.5707426 6.466986,-6.5707426 2.974126,0 4.997218,1.4282706 5.853144,4.1309176 l 0.06057,0.191943 h -2.379302 l -0.0381,-0.08815 c -0.662246,-1.500936 -1.741238,-2.170113 -3.494588,-2.170113 -1.217307,0 -2.251335,0.451305 -2.987954,1.305503 -0.698574,0.810964 -1.08417,1.94702 -1.08417,3.200644 0,1.253625 0.385596,2.391408 1.08417,3.200645 0.736619,0.854186 1.770647,1.305494 2.987954,1.305494 1.782747,0 2.958558,-0.72797 3.491147,-2.161421 l 0.03632,-0.0951 h 2.374112 l -0.04494,0.181568 c -0.632878,2.55394 -2.884213,4.139565 -5.872166,4.139565 z"
            style="stroke-width: 0.172921"
        />
        <rect
            id="rect2"
            class="primary"
            height="12.690179"
            style="stroke-width: 0.172921"
            width="2.3084044"
            x="44.338661"
            y="9.6831932"
        />
        <path
            id="path3"
            class="primary"
            d="m 52.676593,22.617186 c -1.334905,0 -2.545306,-0.478979 -3.409866,-1.350459 -0.87495,-0.88187 -1.355654,-2.132041 -1.355654,-3.520544 0,-1.388502 0.480704,-2.642126 1.355654,-3.52745 0.86456,-0.876675 2.076688,-1.359105 3.409866,-1.359105 1.333165,0 2.545293,0.48243 3.409868,1.359105 0.874948,0.885324 1.355638,2.138948 1.355638,3.52745 0,1.388503 -0.48069,2.638674 -1.355638,3.520544 -0.864575,0.869754 -2.074978,1.350459 -3.409868,1.350459 z m 0,-7.812266 c -1.424819,0 -2.457119,1.238057 -2.457119,2.94299 0,1.704933 1.034028,2.943004 2.457119,2.943004 1.423078,0 2.457106,-1.238071 2.457106,-2.943004 0,-1.704933 -1.034028,-2.94299 -2.457106,-2.94299 z"
            style="stroke-width: 0.172921"
        />
        <path
            id="path4"
            class="primary"
            d="m 62.010497,22.617186 c -2.272098,0 -3.741866,-1.165453 -3.932068,-3.119379 l -0.01562,-0.160805 h 2.282472 l 0.02069,0.121005 c 0.157352,0.900877 0.691653,1.319337 1.678993,1.319337 0.726242,0 1.502629,-0.271481 1.502629,-1.034027 0,-0.674374 -0.582719,-0.8421 -1.902056,-1.155064 -0.100317,-0.02426 -0.204043,-0.04837 -0.311251,-0.07442 -2.014443,-0.461682 -2.994874,-1.371207 -2.994874,-2.782185 0,-1.637506 1.540673,-2.873838 3.584514,-2.873838 2.147595,0 3.551661,1.146417 3.757426,3.065767 l 0.01727,0.162544 h -2.201179 l -0.01727,-0.126228 c -0.04153,-0.300877 -0.28185,-1.279566 -1.590805,-1.279566 -0.722789,0 -1.312427,0.432287 -1.312427,0.964862 0,0.7539 0.970054,0.976963 2.438097,1.315872 1.884761,0.413263 2.840975,1.31588 2.840975,2.67844 0,0.895697 -0.404618,1.658254 -1.168895,2.20466 -0.696844,0.497995 -1.64788,0.771193 -2.676713,0.771193 z"
            style="stroke-width: 0.172921"
        />
        <path
            id="path5"
            class="primary"
            d="M 67.090723,22.375099 V 13.10344 h 2.291105 v 9.271659 z M 67.038843,11.991601 V 9.7177799 h 2.394876 v 2.2738211 z"
            style="stroke-width: 0.172921"
        />
        <path
            id="path6"
            class="primary"
            d="m 77.002165,22.375099 v -5.337864 c 0,-1.523366 -0.504919,-2.232315 -1.589092,-2.232315 -1.312415,0 -2.005796,0.994259 -2.005796,2.873824 v 4.696355 h -2.3084 V 13.10344 h 2.291105 v 1.144689 c 0.504906,-0.880129 1.409251,-1.388501 2.526285,-1.388501 2.176976,0 3.377004,1.334904 3.377004,3.75916 v 5.754584 h -2.291106 z"
            style="stroke-width: 0.172921"
        />
        <rect
            id="rect6"
            class="primary"
            height="12.691903"
            style="stroke-width: 0.172921"
            width="2.3084044"
            x="91.587425"
            y="9.6831932"
        />
        <path
            id="path7"
            class="primary"
            d="m 99.925393,22.617186 c -1.33489,0 -2.547018,-0.478979 -3.409866,-1.350459 -0.874935,-0.88187 -1.355639,-2.132041 -1.355639,-3.520544 0,-1.388502 0.480704,-2.642126 1.355639,-3.52745 0.864575,-0.876675 2.076703,-1.359105 3.409866,-1.359105 1.333177,0 2.545307,0.48243 3.409887,1.359105 0.87493,0.885324 1.35563,2.138948 1.35563,3.52745 0,1.388503 -0.4807,2.638674 -1.35563,3.520544 -0.86458,0.869754 -2.07498,1.350459 -3.409887,1.350459 z m 0,-7.812266 c -1.424804,0 -2.457105,1.238057 -2.457105,2.94299 0,1.704933 1.034028,2.943004 2.457105,2.943004 1.423097,0 2.457117,-1.238071 2.457117,-2.943004 0,-1.704933 -1.03402,-2.94299 -2.457117,-2.94299 z"
            style="stroke-width: 0.172921"
        />
        <path
            id="path8"
            class="primary"
            d="m 110.34176,22.617186 c -1.35911,0 -2.59199,-0.473784 -3.47386,-1.334906 -0.91299,-0.892229 -1.39715,-2.114732 -1.39715,-3.53437 0,-2.877292 2.00236,-4.886557 4.86928,-4.886557 2.23231,0 3.85079,1.229424 4.22428,3.211019 l 0.0329,0.174647 h -2.20813 l -0.0345,-0.09689 c -0.33891,-0.92682 -1.02884,-1.397151 -2.04904,-1.397151 -1.50781,0 -2.56258,1.23115 -2.56258,2.996611 0,1.765457 1.05305,2.979312 2.56258,2.979312 1.0738,0 1.79485,-0.498 2.08189,-1.442105 l 0.0311,-0.103745 h 2.21676 l -0.0363,0.176374 c -0.42537,2.071511 -1.97814,3.259437 -4.25888,3.259437 z"
            style="stroke-width: 0.172921"
        />
        <polygon
            id="polygon8"
            class="primary"
            points="683.05,129.4 669.71,129.4 669.71,56 683.05,56 683.05,96 702.33,75.78 718.67,75.78 696.09,98.89 720,129.4 703.58,129.4 687.15,108.05 683.05,112.23 "
            transform="scale(0.17291421)"
        />
        <path
            id="path9"
            class="primary"
            d="m 85.398876,26.24147 c -2.464026,0 -4.212197,-1.264013 -4.452542,-3.219666 l -0.02069,-0.164273 h 2.268631 l 0.02069,0.121006 c 0.166,0.947568 0.852474,1.388503 2.16489,1.388503 1.410976,0 2.128573,-0.767741 2.128573,-2.284199 v -1.144682 c -0.575797,0.8542 -1.602919,1.366027 -2.804673,1.366027 -1.201754,0 -2.315321,-0.447857 -3.074415,-1.296863 -0.753897,-0.843811 -1.153337,-2.024817 -1.153337,-3.416788 0,-1.391954 0.39944,-2.576414 1.153337,-3.425421 0.759094,-0.8542 1.822517,-1.305508 3.074415,-1.305508 1.175826,0 2.221954,0.541222 2.804673,1.416171 v -1.174086 h 2.360285 v 8.754638 c 0,1.865755 -0.937192,4.383377 -4.469836,4.383377 z M 85.241524,14.80492 c -1.417897,0 -2.370659,1.120473 -2.370659,2.787379 0,1.66689 0.930287,2.770083 2.370659,2.770083 1.440373,0 2.370659,-1.016733 2.370659,-2.718213 0,-1.960846 -1.19138,-2.839249 -2.370659,-2.839249 z"
            style="stroke-width: 0.172921"
        />
    </svg>
</template>

<script setup lang="ts">
withDefaults(
    defineProps<{
        width?: number;
        height?: number;
    }>(),
    {
        height: 28,
        width: 128,
    },
);
</script>

<style scoped>
.primary {
    @apply fill-ds-orange-400;
}
</style>
